import CustomMap from "../components/customMap/customMap";


const Map = () => {
  return <CustomMap />;
};

export default Map;